// MotoEbikes — coverage overlay: curved connectors from Guildford to the biggest city of each covered county
(function () {
  function build(box) {
    if (!box || box._built) return; box._built = true;
    var NS = 'http://www.w3.org/2000/svg';
    var VW = 1120, VH = 760, M = 84;
    function el(n, a) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); return e; }

    var svg = el('svg', { viewBox: '0 0 ' + VW + ' ' + VH, class: 'cov-svg' });
    svg.innerHTML = '<defs><radialGradient id="covGlow" cx="50%" cy="50%" r="50%">' +
      '<stop offset="0%" stop-color="rgba(10,191,113,.32)"/>' +
      '<stop offset="50%" stop-color="rgba(10,191,113,.09)"/>' +
      '<stop offset="100%" stop-color="rgba(10,191,113,0)"/></radialGradient></defs>';
    var clayer = el('g', { class: 'cov-counties' }); svg.appendChild(clayer);
    var glow = el('circle', {}); svg.appendChild(glow);
    var olayer = el('g'); svg.appendChild(olayer);
    box.appendChild(svg);


    var COUNTIES = { 'surrey': 1, 'greater london': 1, 'kent': 1, 'west sussex': 1, 'east sussex': 1, 'berkshire': 1, 'hampshire': 1, 'hertfordshire': 1 };
    var GUI = [51.2356, -0.5704];
    var spokes = [
      ['London', 'London', 51.5074, -0.1278],
      ['Watford', 'Hertfordshire', 51.6565, -0.3903],
      ['Reading', 'Berkshire', 51.4543, -0.9781],
      ['Maidstone', 'Kent', 51.2720, 0.5290],
      ['Southampton', 'Hampshire', 50.9097, -1.4044],
      ['Crawley', 'West Sussex', 51.1092, -0.1872],
      ['Brighton', 'East Sussex', 50.8225, -0.1372]
    ];

    function drawCounties() {
    fetch('https://raw.githubusercontent.com/evansd/uk-ceremonial-counties/master/uk-ceremonial-counties.geojson')
      .then(function (r) { return r.json(); }).then(function (gj) {
        var feats = [], minLon = 999, maxLon = -999, minLat = 999, maxLat = -999;
        (gj.features || []).forEach(function (f) {
          var pr = f.properties || {}, nm = '';
          for (var k in pr) { if (typeof pr[k] === 'string') { var v = pr[k].toLowerCase(); if (COUNTIES[v]) { nm = v; break; } } }
          if (!nm || !f.geometry) return;
          feats.push(f.geometry);
          var polys = f.geometry.type === 'Polygon' ? [f.geometry.coordinates] : f.geometry.coordinates;
          polys.forEach(function (poly) { poly.forEach(function (ring) { ring.forEach(function (pt) {
            if (pt[0] < minLon) minLon = pt[0]; if (pt[0] > maxLon) maxLon = pt[0];
            if (pt[1] < minLat) minLat = pt[1]; if (pt[1] > maxLat) maxLat = pt[1];
          }); }); });
        });
        if (!feats.length) return;
        var midLat = (minLat + maxLat) / 2, cosLat = Math.cos(midLat * Math.PI / 180);
        var wSpan = (maxLon - minLon) * cosLat, hSpan = (maxLat - minLat);
        var scale = Math.min((VW - 2 * M) / wSpan, (VH - 2 * M) / hSpan);
        var offX = (VW - wSpan * scale) / 2, offY = (VH - hSpan * scale) / 2;
        function X(lon) { return offX + (lon - minLon) * cosLat * scale; }
        function Y(lat) { return offY + (maxLat - lat) * scale; }

        feats.forEach(function (geom) {
          var polys = geom.type === 'Polygon' ? [geom.coordinates] : geom.coordinates;
          polys.forEach(function (poly) {
            var d = '';
            poly.forEach(function (ring) { for (var i = 0; i < ring.length; i += 2) { var px = X(ring[i][0]), py = Y(ring[i][1]); d += (i === 0 ? 'M' : 'L') + px.toFixed(1) + ' ' + py.toFixed(1); } d += 'Z'; });
            clayer.appendChild(el('path', { d: d, class: 'cov-cty' }));
          });
        });
        clayer.classList.add('on');

        var gp = { x: X(GUI[1]), y: Y(GUI[0]) };
        glow.setAttribute('cx', gp.x); glow.setAttribute('cy', gp.y); glow.setAttribute('r', Math.min(VW, VH) * 0.5); glow.setAttribute('fill', 'url(#covGlow)');

        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var items = [];
        spokes.forEach(function (s) {
          var t = { x: X(s[3]), y: Y(s[2]) };
          var mx = (gp.x + t.x) / 2, my = (gp.y + t.y) / 2, dx = t.x - gp.x, dy = t.y - gp.y, L = Math.hypot(dx, dy) || 1, bend = 28;
          var path = el('path', { d: 'M' + gp.x.toFixed(1) + ' ' + gp.y.toFixed(1) + ' Q' + (mx + (-dy / L) * bend).toFixed(1) + ' ' + (my + (dx / L) * bend).toFixed(1) + ' ' + t.x.toFixed(1) + ' ' + t.y.toFixed(1), class: 'cov-conn' });
          olayer.appendChild(path);
          var dot = el('circle', { cx: t.x, cy: t.y, r: 5, class: 'cov-dot' }); olayer.appendChild(dot);
          var left = t.x < gp.x;
          var lab = el('text', { x: t.x + (left ? -13 : 13), y: t.y + (dy < -30 ? -14 : (dy > 30 ? 22 : 5)), class: 'cov-label', 'text-anchor': left ? 'end' : 'start' }); lab.textContent = s[0].toUpperCase(); olayer.appendChild(lab);
          var sub = el('text', { x: t.x + (left ? -13 : 13), y: t.y + (dy < -30 ? 2 : (dy > 30 ? 38 : 21)), class: 'cov-city', 'text-anchor': left ? 'end' : 'start' }); sub.textContent = s[1]; olayer.appendChild(sub);
          items.push({ path: path, dot: dot, lab: lab, sub: sub });
        });

        olayer.appendChild(el('circle', { cx: gp.x, cy: gp.y, r: 13, class: 'cov-home-glow' }));
        olayer.appendChild(el('circle', { cx: gp.x, cy: gp.y, r: 6, class: 'cov-home' }));
        var gl = el('text', { x: gp.x, y: gp.y + 26, class: 'cov-center-label', 'text-anchor': 'middle' }); gl.textContent = 'GUILDFORD'; olayer.appendChild(gl);

        items.forEach(function (it) { var len = it.path.getTotalLength(); it._len = len; it.path.style.strokeDasharray = len; it.path.style.strokeDashoffset = reduce ? 0 : len; [it.dot, it.lab, it.sub].forEach(function (e) { e.style.opacity = reduce ? 1 : 0; e.style.transition = 'opacity .5s ease'; }); });
        if (!reduce) {
          var io = new IntersectionObserver(function (es) {
            es.forEach(function (e) {
              if (e.isIntersecting) { items.forEach(function (it, i) { setTimeout(function () { it.path.style.transition = 'stroke-dashoffset 1s ease'; it.path.style.strokeDashoffset = 0; it.dot.style.opacity = 1; it.lab.style.opacity = 1; it.sub.style.opacity = 1; }, 250 + i * 240); }); }
              else { items.forEach(function (it) { it.path.style.transition = 'none'; it.path.style.strokeDashoffset = it._len; it.dot.style.opacity = 0; it.lab.style.opacity = 0; it.sub.style.opacity = 0; }); }
            });
          }, { threshold: 0.25 });
          io.observe(box);
        }
      }).catch(function () {});
    }
    // Lazy: fetch the large county boundaries file only when the map nears the viewport (perf: avoids ~17 MB on load).
    // Uses real geometry checked after load (IntersectionObserver can false-fire on transient early layout).
    var geoLoaded = false;
    function nearCheck() {
      if (geoLoaded) return;
      var r = box.getBoundingClientRect();
      if (r.top < (window.innerHeight || 0) + 600 && r.bottom > -600) {
        geoLoaded = true;
        window.removeEventListener('scroll', nearCheck);
        window.removeEventListener('resize', nearCheck);
        drawCounties();
      }
    }
    window.addEventListener('scroll', nearCheck, { passive: true });
    window.addEventListener('resize', nearCheck, { passive: true });
    if (document.readyState === 'complete') { requestAnimationFrame(nearCheck); }
    else { window.addEventListener('load', function () { requestAnimationFrame(nearCheck); }); }
  }
  function init() {
    var boxes = document.querySelectorAll('.covmap');
    for (var i = 0; i < boxes.length; i++) build(boxes[i]);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
